<template>
    <el-form class="yq-search-form" inline :model="searchModel">
        <el-form-item label="ID" prop="_id">
            <el-input v-model="searchModel._id" style="width: 80px;"></el-input>
        </el-form-item>
        <el-form-item v-for="field in searchFields" :key="field.name" :label="field.title" :prop="field.name">
            <el-select v-if="field.type === 'BOOLEAN'" v-model="searchModel[field.name]" clearable>
                <el-option :value="true" label="是"></el-option>
                <el-option :value="false" label="否"></el-option>
            </el-select>
            <date-interval-picker v-else-if="field.type === 'DATETIME'" v-model="searchModel[field.name]" size></date-interval-picker>
            <date-interval-picker v-else-if="field.type === 'DATE'" type="daterange" v-model="searchModel[field.name]" size></date-interval-picker>
            <time-interval-picker v-else-if="field.type === 'TIME'" v-model="searchModel[field.name]" size></time-interval-picker>
            <el-input v-else-if="field.type === 'KEYWORD' && !field.supportWildcast && !field.supportMultiValue"
                      v-model="searchModel[field.name]"></el-input>
            <el-select v-else-if="field.type === 'KEYWORD' && !field.supportWildcast && field.supportMultiValue"
                       v-model="searchModel[field.name]" placeholder="" multiple clearable allow-create filterable
                       default-first-option no-data-text="请输入检索词并回车">
            </el-select>
            <span v-else-if="field.type === 'KEYWORD' && field.supportWildcast && !field.supportMultiValue">
                <el-select v-model="searchModel[field.name].op" style="width: 110px;">
                    <el-option label="精确匹配" value="eq"></el-option>
                    <el-option label="模糊匹配" value="like"></el-option>
                </el-select>
                <el-input v-model="searchModel[field.name].value"></el-input>
            </span>
            <span v-else-if="field.type === 'KEYWORD' && field.supportWildcast && field.supportMultiValue">
                <el-select v-model="searchModel[field.name].op" placeholder="匹配方式" style="width: 110px;">
                    <el-option label="精确匹配" value="eq"></el-option>
                    <el-option label="模糊匹配" value="like"></el-option>
                </el-select>
                <el-select v-model="searchModel[field.name].value" multiple clearable allow-create filterable placeholder="" no-data-text="请输入检索词并回车"></el-select>
            </span>
            <el-input v-else-if="field.type === 'TEXT'" v-model="searchModel[field.name]"></el-input>
            <el-input v-else-if="field.type === 'LONG'||field.type === 'INTEGER'||field.type === 'SHORT'||field.type === 'DOUBLE'||field.type === 'FLOAT'" v-model.number="searchModel[field.name]"></el-input>
        </el-form-item>
        <slot name="fields"></slot>
        <el-form-item>
            <el-button type="primary" @click="search">搜索</el-button>
            <slot name="ops"></slot>
        </el-form-item>
    </el-form>
</template>

<script>
    import DateIntervalPicker from './DateIntervalPicker'
    import TimeIntervalPicker from './TimeIntervalPicker'
    import dateUtils from '../../service/date-utils'

    export default {
        name: "NewsQuery",
        components: {DateIntervalPicker, TimeIntervalPicker},
        props: {
            datasource: Object,
            timeField: String,
            timeInterval: String,

        },
        data(){
            const searchFields = []
            const searchModel = {
                _id: null
            }
            for(const field of this.datasource.fields){
                if(!field.searchable){
                    continue
                }
                searchFields.push(field)
                if(field.type === 'KEYWORD' && field.supportWildcast){
                    searchModel[field.name] = {
                        op: 'eq',
                        value: null
                    }
                }else if(field.name === this.timeField){
                    searchModel[field.name] = this.timeInterval
                }else{
                    searchModel[field.name] = null
                }
            }
            return {
                searchFields,
                searchModel
            }
        },
        methods: {
            search(){
                const query = []
                if(this.searchModel._id){
                    query.push('(_id:"'+this.searchModel._id+'")')
                }
                for(const field of this.searchFields){
                    if(field.type === 'KEYWORD' && field.supportWildcast){
                        const op = this.searchModel[field.name].op
                        const value = this.searchModel[field.name].value
                        if(Array.isArray(value)){
                            if(value.length>0){
                                if(op === 'like'){
                                    query.push('('+field.name+':('+value.map(item => '*'+item+'*').join(' OR ')+'))')
                                }else{
                                    query.push('('+field.name+':('+value.join(' OR ')+'))')
                                }
                            }
                        }else if(value){
                            if(op === 'like'){
                                query.push('('+field.name+':(*'+value+'*))')
                            }else{
                                query.push('('+field.name+':('+value+'))')
                            }
                        }
                    }else if(field.type === 'DATETIME'){
                        const value = this.searchModel[field.name]
                        if(value){
                            const parsedValue = dateUtils.parseDateTimeInterval(value)
                            if(parsedValue.range){
                                query.push('('+field.name+':["'
                                    +dateUtils.javaFormatDateTime(parsedValue.range[0], field.dateValueFormat)+'" TO "'
                                    +dateUtils.javaFormatDateTime(parsedValue.range[1], field.dateValueFormat)+'"])')
                            }
                        }
                    }else if(field.type === 'DATE'){
                        const value = this.searchModel[field.name]
                        if(value){
                            const parsedValue = dateUtils.parseDateInterval(value)
                            if(parsedValue.range){
                                query.push('('+field.name+':["'
                                    +dateUtils.javaFormatDate(parsedValue.range[0], field.dateValueFormat)+'" TO "'
                                    +dateUtils.javaFormatDate(parsedValue.range[1], field.dateValueFormat)+'"])')
                            }
                        }
                    }else if(field.type === 'TIME'){
                        const value = this.searchModel[field.name]
                        if(value){
                            const parsedValue = dateUtils.parseTimeInterval(value)
                            if(parsedValue.range){
                                query.push('('+field.name+':["'
                                    +dateUtils.javaFormatTime(parsedValue.range[0], field.dateValueFormat)+'" TO "'
                                    +dateUtils.javaFormatTime(parsedValue.range[1], field.dateValueFormat)+'"])')
                            }
                        }
                    }else if(this.searchModel[field.name]){
                        const value = this.searchModel[field.name]
                        if(Array.isArray(value)){
                            if(value.length>0){
                                query.push(field.name+':('+value.map(item => '"'+item+'"').join(' OR ')+')')
                            }
                        }else{
                            query.push(''+field.name+':("'+value+'")')
                        }
                    }
                }
                this.$emit('search', query.join(' AND '))
            }
        }
    }
</script>

<style scoped>

</style>
